// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__prDC6","productName":"Table_productName__3SVFj"};